export interface ClientPriceApprovalReminder {
  id: number; kind: 'client_price_approval'; title: string; message: string; path: string;
  assignment_required: boolean; request: {id: number; code: string};
}

/** Same authorized, deduplicated approval queue for the counter and its destination list. */
export function clientPriceApprovalItems(value: unknown): ClientPriceApprovalReminder[] {
  if (!Array.isArray(value)) return [];
  const items = new Map<number, ClientPriceApprovalReminder>();
  for (const item of value) {
    if (item?.kind !== 'client_price_approval' || !Number.isSafeInteger(item.id) || item.id <= 0
      || item.path !== '/dashboard/form/activities/' + item.id || !Number.isSafeInteger(item.request?.id)
      || item.request.id <= 0 || typeof item.request.code !== 'string' || !item.request.code.trim()) continue;
    if (!items.has(item.id)) items.set(item.id, item);
  }
  return [...items.values()];
}
